/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingInformationDetailForAws extends models.BillingInformationBase {
    constructor() {
        super();
        this.setDiscriminator("BillingInformationDetailForAws");
    }

    getFixupPrototypeFunction() { return BillingInformationDetailForAws.fixupPrototype; }

    static newInstance(model: Partial<BillingInformationDetailForAws>): BillingInformationDetailForAws {
        let obj = Object.assign(new BillingInformationDetailForAws(), model);
        BillingInformationDetailForAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingInformationDetailForAws>): BillingInformationDetailForAws {
        if (!model) return null;
        return BillingInformationDetailForAws.newInstance(<BillingInformationDetailForAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingInformationDetailForAws) {
        if (!obj) return;

        models.BillingInformationDetailForAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingInformationDetailForAws): boolean {
        if (models.BillingInformationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingInformationDetailForAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.billing_periods) {
            for (let val of this.billing_periods) {
                models.BillingInformationForAws.fixupPrototype(val);
            }
        }
    }

    /**
     * Details for the billing period.
     */
    billing_periods: Array<models.BillingInformationForAws>;

}
